import apiService from './apiService';

/**
 * Service pour les produits
 */
class ProductService {
  /**
   * Récupère la liste des produits avec filtres
   * @param {Object} params - Paramètres de recherche (search, paginate, orderby, order)
   */
  async getProducts(params = {}) {
    const response = await apiService.get('/products', params);
    return response.data;
  }

  /**
   * Comme {@link getProducts}, mais renvoie le corps complet `{ data, links, meta }`.
   *
   * `getProducts` n'en garde que `data` (un tableau) : la pagination
   * (`meta.last_page`, `meta.total`) est perdue. Un appelant qui veut savoir
   * s'il reste des pages à charger passe par ici.
   * @param {Object} params - Paramètres de recherche (paginate, page, is_business_offer…)
   */
  async getProductsPage(params = {}) {
    return apiService.get('/products', params);
  }

  /**
   * Récupère un produit spécifique
   * @param {string} id - ID du produit
   */
  async getProduct(id, params = {}) {
    const response = await apiService.get(`/products/${id}`, params);
    return response.data;
  }

  /**
   * Crée un nouveau produit
   * @param {Object} productData - Données du produit
   */
  async createProduct(productData) {
    const response = await apiService.post('/products', productData);
    return response.data;
  }

  /**
   * Met à jour un produit
   * @param {string} id - ID du produit
   * @param {Object} productData - Nouvelles données
   */
  async updateProduct(id, productData) {
    const response = await apiService.put(`/products/${id}`, productData);
    return response.data;
  }

  /**
   * Supprime un produit
   * @param {string} id - ID du produit
   */
  async deleteProduct(id) {
    return apiService.delete(`/products/${id}`);
  }

  /**
   * Upload d'images pour un produit
   * @param {string} productId - ID du produit
   * @param {File[]} images - Fichiers images
   */
  async uploadProductImages(productId, images) {
    const formData = new FormData();
    images.forEach((image, index) => {
      formData.append(`images[${index}]`, image);
    });
    const response = await apiService.upload(`/products/${productId}/images`, formData);
    return response.data;
  }

  async checkVariant(productId, { attribute_values, product_type, quantity }) {
    const body = {};
    if (Array.isArray(attribute_values)) body.attribute_values = attribute_values;
    if (product_type) body.product_type = product_type;
    if (quantity !== undefined && quantity !== null) body.quantity = quantity;

    const response = await apiService.post(`/products/${productId}/variants`, body);
    return response;
  }
}

const productServiceInstance = new ProductService();
export default productServiceInstance;
